import { Currency } from "@redotech/money/currencies";
import type { ProgressBar as ProgressBarType } from "@redotech/redo-conversion-settings-common/checkout-optimization-settings";
import { useTranslation } from "@redotech/redo-i18n";
import { ProgressBar } from "@redotech/redo-web-conversion/conversion/storefront-widgets/progress-bar";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useMemo } from "react";

export const PreviewSection = memo(function PreviewSection({
  progressBarConfig,
  shopCurrency,
}: {
  progressBarConfig:
    | {
        threshold: ProgressBarType["threshold"];
        ltThresholdText: string;
        gteThresholdText: string;
        progressBarColor: string;
      }
    | undefined;
  shopCurrency: Currency;
}) {
  const { t } = useTranslation();
  const mockCart = useMemo(() => {
    if (!progressBarConfig) {
      return undefined;
    }

    const thresholdAmount = progressBarConfig.threshold.amount;
    const subtotal = Math.floor(thresholdAmount * 0.6);

    return { currency: shopCurrency, subtotal_price: subtotal, items: [] };
  }, [progressBarConfig, shopCurrency]);

  return (
    <Flex dir="column" flex={1} gap="3xl" p="3xl">
      <Text fontSize="md" fontWeight="semibold" textColor="primary">
        {t("Preview")}
      </Text>
      {progressBarConfig && mockCart ? (
        <ProgressBar
          cart={mockCart}
          gteThresholdText={progressBarConfig.gteThresholdText}
          ltThresholdText={progressBarConfig.ltThresholdText}
          progressBarColor={progressBarConfig.progressBarColor}
          threshold={progressBarConfig.threshold}
        />
      ) : (
        <Flex
          align="center"
          bgColor="secondary"
          borderRadius="lg"
          dir="row"
          justify="center"
          p="5xl"
          w="full"
        >
          <Text fontSize="sm" textAlign="center" textColor="secondary">
            {t(
              "The preview of the progress bar widget will appear when configured",
            )}
          </Text>
        </Flex>
      )}
    </Flex>
  );
});
